import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../environments/environment';
import { of, Observable } from 'rxjs';
import { catchError} from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export class UtilService {
    url = "";
    
    constructor(private http: HttpClient) {
        this.url = environment.API;
    }

    public getProvinces(): Observable<any> {
        return this.http.get<any>(`${this.url}${environment.URL_GET_PROVINCE}`)
            .pipe(
                catchError(error => {
                    return of(error.error);
                }));
    }

    public getDistricts(id): Observable<any> {
        return this.http.get<any>(`${this.url}${environment.URL_GET_DISTRICT}/${id}`)
            .pipe(
                catchError(error => {
                    return of(error.error);
                }));
    }

    public getSubDistricts(id): Observable<any> {
        return this.http.get<any>(`${this.url}${environment.URL_GET_SUB_DISTRICT}/${id}`)
            .pipe(
                catchError(error => {
                    return of(error.error);
                }));
    }

    public uploadImage(formData): Observable<any> {
        return this.http.post<any>(`${this.url}${environment.URL_UPLOAD_IMAGE}`, formData)
        .pipe(
            catchError(error => {
                return of(error.error);
            }));
    }
}
